import React, {
  memo, useMemo, useEffect, useState,
} from 'react';
import useCompetitionCountdown from 'hooks/useCompetitionCountdown';
import { Typography } from '@mui/material';
import CompetitionHeaderStyles from 'components/pages/Competition/CompetitionHeader/competitionHeader.styles';
import { COMPETITION_UPCOMING_STATUS } from 'constants/competitions';
import { Box } from '@mui/system';

const CompetitionCountdownTimer = memo(({
  start,
  end,
  status,
  onCountdownEnd,
}) => {
  const config = useMemo(() => ({ start, end, status }), [start, end, status]);
  const {
    timeLeft,
    retryStatus,
  } = useCompetitionCountdown(config, onCountdownEnd, status === COMPETITION_UPCOMING_STATUS ? 'till the start' : 'to go');

  // Opacity state to control transition
  const [opacity, setOpacity] = useState(0.1); // Start from invisible

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 300); // Small delay ensures transition kicks in

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        className="monospace"
        sx={{
          opacity,
          transition: 'opacity 300ms ease-in-out',
          ...CompetitionHeaderStyles.status(status),
          fontSize: '16px',
          lineHeight: '16px',
        }}
        component="div"
      >
        {`${retryStatus || timeLeft || '00:00:00'} `}
      </Typography>
    </Box>

  );
});

CompetitionCountdownTimer.displayName = 'CompetitionCountdownTimer';

export default CompetitionCountdownTimer;

// "248718b862a9c60ad4eae4942f616b92"
/*
* x-goog-generation:1740657556223316
x-goog-hash:crc32c=OIz/+g==, md5=JIcYuGKpxgrU6uSUL2Frkg==
x-goog-metageneration:2
x-goog-storage-class:STANDARD
x-goog-stored-content-encoding:identity
x-goog-stored-content-length:29235
x-guploader-uploadid:AHMx-iFBQjUVsPMMRvKIC2pMyXScfo9dK8OMz55fqKxMti85jr11UlGjkyEUzMr_9J9BbqTmm6GoPWE */
